/** What a promoted lead becomes.
 *
 *  Not a free-text field and not a guess. A lead is almost always one of these
 *  four — DIRECTION's own examples are a festival and a special market — and
 *  the type drives the lane, so getting it wrong hides the card somewhere Doug
 *  will not look. Four buttons is cheaper than a wrong default.
 *
 *  Shared between the phone app's Saved screen and the admin console's Leads
 *  section, which is where Doug asked lead management to live going
 *  forward — one list rather than two that could answer differently. */
export const PROMOTE_TYPES: { type: string; label: string }[] = [
  { type: 'festival', label: 'Festival' },
  { type: 'market', label: 'Market' },
  { type: 'talk', label: 'Talk' },
  { type: 'exhibition', label: 'Exhibition' },
]
